import Collection from '@/components/Collection'
import CreateDomain from '@/pages/domain/CreateForm'
import ViewDomain from '@/pages/domain/Detail'
import EditDomain from '@/pages/domain/Update'
import RenewDomain from '@/pages/domain/Renew'
import DeleteDomain from '@/pages/domain/DeleteForm'
import DirectDomainUpdate from '@/pages/domain/UpdateDirect'
import BlackList from '@/pages/domain/BlackList'
import access from "../access";

const domainNs = "urn:ietf:params:xml:ns:domain-1.0";

export default {

  'domain.collection': {
    path: '/admin/domains',
    name: 'domain.collection',
    component:  Object.assign({}, Collection), // https://stackoverflow.com/a/41425312
    props: {
      handler: "listDomains",
      entity: "domain",
      cols: [
        { label: "Domain", sort: "domain", html: (row) => '<a href="http://' + row.domain + '" target="_blank" class="nobreak">' + row.domain + ' <i class="icon icon-new-tab"></i></a>' },
        { label: "Contact", sort: "owner_cid", field: "owner_cid" },
        { label: "Registrar", sort: "owner_rid", field: "owner_rid" },
        { label: "Expiration date", sort: "expire_at", field: "expire_at", date: "date" },
        { label: "Transfer date", sort: "transfer_at", field: "transfer_at", date: "date" },
        { label: "Status", html: (row) => row.status.join('<br>') },
      ],
      actions: (row) => {
        return [
          { name: "domain.view", label: "view", icon: "eye", params: {domain: row.domain} },
          { name: "domain.update", label: "edit", icon: "pencil2", params: {domain: row.domain} },
          { name: "domain.renew", label: "renew", icon: "spinner11", params: {domain: row.domain} },
          { name: "domain.delete", label: "delete", icon: "bin", params: {domain: row.domain} },
        ];
      }
    },
    meta: {
      access: access.chain(access.authenticated, access.service(domainNs)),
      title: "Domain list",
      side_menu: { label: "Domains",  icon: "point-up" },
      local_actions: [
        { name: "domain.create", label: "Create domain", color: "success", icon: "plus" },
        { name: "domain.blacklist", label: "Domain blacklist", color: "secondary", icon: "hammer2" }
      ]
    },
  },

  'domain.create': {
    path: '/admin/domains/create',
    name: 'domain.create',
    component: CreateDomain,
    meta: {
      title: "Create new domain"
    },
  },

  'domain.view': {
    path: '/admin/domains/view/:domain',
    name: 'domain.view',
    component: ViewDomain,
    props: true,
    meta: {
      access: access.chain(access.authenticated, access.service(domainNs)),
      title: "Domain details",
      local_tasks: [
        { name: "domain.view", label: "View"},
        { name: "domain.update", label: "Edit"},
        { name: "domain.update_direct", label: "Edit direct"},
        { name: "domain.renew", label: "Renew"},
        { name: "domain.delete", label: "Delete"}
      ]
    },
  },

  'domain.update': {
    path: '/admin/domains/edit/:domain',
    name: 'domain.update',
    component: EditDomain,
    props: true,
    meta: {
      access: access.chain(access.authenticated, access.service(domainNs)),
      title: "Update domain details",
      local_tasks: [
        { name: "domain.view", label: "View"},
        { name: "domain.update", label: "Edit"},
        { name: "domain.update_direct", label: "Edit direct"},
        { name: "domain.renew", label: "Renew"},
        { name: "domain.delete", label: "Delete"}
      ]
    },
  },

  'domain.update_direct': {
    path: '/admin/domains/edit-direct/:domain',
    name: 'domain.update_direct',
    component: DirectDomainUpdate,
    props: true,
    meta: {
      access: access.chain(access.admin, access.service(domainNs)),
      title: "Update domain details",
      local_tasks: [
        { name: "domain.view", label: "View"},
        { name: "domain.update", label: "Edit"},
        { name: "domain.update_direct", label: "Edit direct"},
        { name: "domain.renew", label: "Renew"},
        { name: "domain.delete", label: "Delete"}
      ]
    },
  },

  'domain.delete': {
    path: '/admin/domains/delete/:domain',
    name: 'domain.delete',
    component: DeleteDomain,
    props: true,
    meta: {
      access: access.chain(access.authenticated, access.service(domainNs)),
      title: "Delete domain",
      local_tasks: [
        { name: "domain.view", label: "View"},
        { name: "domain.update", label: "Edit"},
        { name: "domain.update_direct", label: "Edit direct"},
        { name: "domain.renew", label: "Renew"},
        { name: "domain.delete", label: "Delete"}
      ]
    },
  },

  'domain.blacklist': {
    path: '/admin/domains/blacklist',
    name: 'domain.blacklist',
    component: BlackList,
    meta: {
      access: access.chain(access.admin, access.service(domainNs)),
      title: "Domain blacklist"
    },
  },

  'domain.renew': {
    path: '/admin/domains/renew/:domain',
    name: 'domain.renew',
    component: RenewDomain,
    props: true,
    meta: {
      access: access.chain(access.authenticated, access.service(domainNs)),
      title: "Renew domain",
      local_tasks: [
        { name: "domain.view", label: "View"},
        { name: "domain.update", label: "Edit"},
        { name: "domain.update_direct", label: "Edit direct"},
        { name: "domain.renew", label: "Renew"},
        { name: "domain.delete", label: "Delete"}
      ]
    },
  },

}



// WEBPACK FOOTER //
// ./src/routes/modules/domain.js